module.exports = "/_next/static/images/nikhil-2f9110c9a76a8520f86eccc1bcd9a211.png";